/**
 * @name ReportAccessService
 * @description Servicio para gestionar el acceso a los reportes de Talentry
 * @author Gabriela Urenda | Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta que reportes se pueden consulta en base a los permisos del colaborador
 * @param {number} idApp 
 * @param {boolean} isAdmin
 * @return {any} promise
 */
const get = (idApp, isAdmin = false) => {
  let URL = `${BASE_URL}/Reporte/${idApp}?esAdmin=${isAdmin}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Actualiza que reportes se pueden consulta en base a los permisos del colaborador
 * @param {array} reports
 * @return {any} promise
 */
const put = (reports) => {
  return axios.get(`${BASE_URL}/Reporte`, reports).then(({ data }) => {
    return data;
  });
};

export const ReportAccessService = {
  get,
  put
};